<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellTestedToTreatmentConversionRate',
    extends: TableCellBase,
    data() {
      return {
        testsFields: [
          'tests_ige',
          'tests_mqt',
          'tests_pricks',
          'tests_sticks',
        ],
        vialsFields: [
          'scit_vials_new_patients',
          'slit_vials_new_patients',
        ],
      };
    },
    computed: {
      actualTestsRaw() {
        return lodash.reduce(this.testsFields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
      actualVialsRaw() {
        return lodash.reduce(this.vialsFields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
      actualValueRaw() {
        return this.round(this.getRatio(this.actualVialsRaw, this.actualTestsRaw), 2);
      },
      benchmarkYtdRaw() {
        if (this.type == 'percent' || this.aggregateType == 'avg') {
          return this.benchmarkMonth[this.field];
        }
        return this.getYtdAdjusted(this.benchmarkYear, this.month);
      },
    },
  };
</script>
